// Polyfills for IE 11 & others...
require('core-js/fn/promise');
require('core-js/fn/object/assign');
require('core-js/fn/object/entries');
require('core-js/fn/object/keys');
require('core-js/fn/object/values');
require('core-js/fn/array/from');
require('core-js/fn/array/find');
require('core-js/fn/array/includes');
require('core-js/fn/string/includes');
require('core-js/fn/string/starts-with');
// Used by babel-preset-react-optimize when doing build optimizations
require('core-js/modules/es6.symbol');


// Element.matches
if (!Element.prototype.matches){
    console.log('Adding: Element.prototype.matches');
    Element.prototype.matches = Element.prototype.oMatchesSelector
        || Element.prototype.msMatchesSelector
        || Element.prototype.mozMatchesSelector
        || Element.prototype.webkitMatchesSelector;
}

// Element.closest
if (!Element.prototype.closest) {
    console.log('Adding: Element.prototype.closest');
    Element.prototype.closest = function(s) {
        var el = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

// Element.remove()
// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('remove')) {
        return;
      }
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          this.parentNode.removeChild(this);
        }
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);



// WEBPACK FOOTER //
// ../polyfills.js